// Planner ActionGroup Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Button from '../../common/button/button.jsx'

class PlannerActionGroup extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      actions: PropTypes.array,
      activeActions: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      title: '',
      actions: [],
      activeActions: [],
      onChange: null
    }
  }

  render () {
    const { actions, activeActions, onChange } = this.props

    return (
      <div className='planner-actiongroup'>
        <div className='content'>
          {actions.map(action => (
            <Button
              className='actionbutton'
              key={action.ident}
              title={action.title}
              type={action.type || 'select'}
              inActive={
                activeActions && activeActions.indexOf(action.ident) < 0
              }
              hasBorder
              onClick={ev => onChange && onChange(action, ev)}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default PlannerActionGroup
